import React from 'react';
import { FiX } from 'react-icons/fi';

// Small single-field modal used for naming categories, separators, and folders.
// (Ported from the legacy APMiniInputModal; shares the apc* modal styling.)
export default function CurriculumMiniInputModal({
  title,
  label,
  value,
  onChange,
  onCancel,
  onSubmit,
  submitting,
  submitLabel = 'Save',
}) {
  return (
    <div className="apcModal__overlay" role="dialog" aria-modal="true">
      <div className="apcModal__card apcModal__card--mini">
        <div className="apcModal__header">
          <h3>{title}</h3>
          <button type="button" className="apcIconBtn" onClick={onCancel}>
            <FiX />
          </button>
        </div>

        <div className="apcModal__body">
          <label className="apcField">
            <span>{label}</span>
            <input
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') onSubmit();
              }}
              autoFocus
            />
          </label>
        </div>

        <div className="apcModal__footer">
          <button type="button" className="apcBtn apcBtn--ghost" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="apcBtn apcBtn--primary" onClick={onSubmit} disabled={submitting}>
            {submitting ? 'Saving...' : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
